import btc3 from "../../assets/images/btc3.png";
import btc1 from "../../assets/images/btc1.png";
import Img from "../../assets/images/img.png";
import btc2 from "../../assets/images/btc2.png";
import btc4 from "../../assets/images/btc4.png";
import btc5 from "../../assets/images/btc5.png";
import btc6 from "../../assets/images/btc6.png";
import btc7 from "../../assets/images/btc7.png";
import btc8 from "../../assets/images/btc8.png";
import exclamation from "../../assets/images/c-info-e.svg";
import defilogo from "../../assets/images/Logo.svg";
import btc9 from "../../assets/images/btc9.png";
import btc10 from "../../assets/images/btc10.png";
import market from "../../assets/images/market.png";
import btc from "../../assets/images/btc.png";
import crt1 from "../../assets/images/crt1.png";
import crt2 from "../../assets/images/crt2.png";
import comp from "../../assets/images/comp.png";
import assest from "../../assets/images/assest.png";
import Yield from "../../assets/images/yield.png";
import moreright from "../../assets/images/moreright.png";
import crt3 from "../../assets/images/crt3.png";
import crt4 from "../../assets/images/crt4.png";
import towardarrow from "../../assets/images/towardarrow.png";
import Wallet from "../../assets/images/wallet.png";
import cr1 from "../../assets/images/cr1.png";
import cr2 from "../../assets/images/cr2.png";
import cr3 from "../../assets/images/cr3.png";
import lorarrow from "../../assets/images/Arrow-icon.svg";
import mainbanneri from "../../assets/images/mainbanneri.png";
import Yay from "../../assets/images/Yay.png";
import From from "../../assets/images/from.png";
import to from "../../assets/images/to.png";
import proto from "../../assets/images/proto.png";
import pt1 from "../../assets/images/pt1.png";
import pt2 from "../../assets/images/pt2.png";
import pt3 from "../../assets/images/pt3.png";
import pt4 from "../../assets/images/pt4.png";
import rightarr from "../../assets/images/rightarr.png";
import warrr from "../../assets/images/warrr.png";
import setting from "../../assets/images/setting.png";
import down from "../../assets/images/down.svg";
import goup3 from "../../assets/images/goup3.png";
import hourr from "../../assets/images/hourr.png";
import up from "../../assets/images/up-ar.svg";
import sss from "../../assets/images/sss.png";
import clock from "../../assets/images/clock.png";
import bbbtc from "../../assets/images/buybtc.png";
import linechart from "../../assets/images/linechart.png";
import bnb from "../../assets/images/bnb.png";
import frame1 from "../../assets/images/frame1.png";
import frame2 from "../../assets/images/frame2.png";
import frame3 from "../../assets/images/frame3.png";
import gotomarket from "../../assets/images/gotomarket.png";
import percentage from "../../assets/images/percentage.png";
import yielldmarket from "../../assets/images/yielldmarket.png";
import qwq from "../../assets/images/qwq.png";
import lefttwoline from "../../assets/images/lefttwoline.png";
import fb from "../../assets/images/fb.png";
import twit from "../../assets/images/twit.png";
import insta from "../../assets/images/insta.png";
import tether from "../../assets/images/tether.png";
import goll from "../../assets/images/goll.png";
import pageyeild from "../../assets/images/pageyeild.png";
import dolaar from "../../assets/images/dolaar.png";
import uptwo from "../../assets/images/uptwo.png";
import nameup from "../../assets/images/nameup.png";
import searchbarr from "../../assets/images/searchbarr.png";
import overview from "../../assets/images/overview.png";
import seeall from "../../assets/images/seeall.png";
import bitcoinnn from "../../assets/images/bitcoinnn.png";
import at6 from "../../assets/images/at6.png";
import at5 from "../../assets/images/at5.png";
import purple from "../../assets/images/purple.png";
import crossicon from "../../assets/images/crossicon.png";
import searchicon from "../../assets/images/searchicon.png";
import iconarowdown from "../../assets/images/iconarowdown.png";
import refreashicon from "../../assets/images/icon_refresh.svg";
import iconquestion from "../../assets/images/icon-question.svg";
import iconsrightline from "../../assets/images/iconsrightline.svg";
import iconsLeftline from "../../assets/images/iconsLeftline.svg";
import loadicon from "../../assets/images/loadicon.png";
import learnsearch from "../../assets/images/learnsearch.png";
import ButtonSecondarySmall from "../../assets/images/ButtonSecondarySmall.png";
import learnvideo from "../../assets/images/learnvideo.png";
import trainer from "../../assets/images/trainer.png";
import exportIcon from "../../assets/images/exportIcon.png";
import traineravatar from "../../assets/images/traineravatar.png";
import morearticle from "../../assets/images/morearticle.png";
import FilterUp from "../../assets/images/FilterUp.png";
import FilterDown from "../../assets/images/FilterDown.png";
import mediacontainer from "../../assets/images/mediacontainer.png";
import homevideo from "../../assets/images/homevideo.png";
import homeimg from "../../assets/images/homeimg.png";
import chartmarket from "../../assets/images/chartmarket.png";
import articlevideo from "../../assets/images/articlevideo.png";
import articleimage from "../../assets/images/articleimage.png";
import stepOne from "../../assets/images/step-one.png";
import stepTwo from "../../assets/images/step-two.png";
import wallettop from "../../assets/images/wallet-2.png";
import stepThree from "../../assets/images/step-three.png";
import placeholder from "../../assets/images/placeholder.png";
import us from "../../assets/images/US.svg";
import vn from "../../assets/images/VN.svg";
import ru from "../../assets/images/RU.svg";
import cap from "../../assets/images/dropdown-cap.svg";
import notificationdot from "../../assets/images/notification-dot.svg";
import firstarticle from "../../assets/images/firstArti.png";
import secondarticle from "../../assets/images/secondArti.png";
import thirdarticle from "../../assets/images/thirdArti.png";
import bch from "../../assets/images/bch.png";
import eth from "../../assets/images/eth.png";
import ltc from "../../assets/images/ltc.png";
import runeImg from "../../assets/images/RUNE.png";
import defispotlogo from "../../assets/images/defispot-logo.svg"
import newdefilogo from "../../assets/images/new-defiLogo.png"

const Images = {
  runeImg,
  defispotlogo,
  newdefilogo,
  FilterDown,
  FilterUp,
  exportIcon,
  chartmarket,
  searchbarr,
  homeimg,
  towardarrow,
  placeholder,
  homevideo,
  overview,
  traineravatar,
  mediacontainer,
  morearticle,
  trainer,
  ButtonSecondarySmall,
  learnvideo,
  iconarowdown,
  refreashicon,
  iconquestion,
  learnsearch,
  loadicon,
  searchicon,
  iconsrightline,
  iconsLeftline,
  seeall,
  purple,
  crossicon,
  at6,
  at5,
  bitcoinnn,
  pageyeild,
  tether,
  goll,
  Img,
  fb,
  uptwo,
  nameup,
  insta,
  dolaar,
  twit,
  btc,
  btc1,
  setting,
  btc2,
  btc3,
  btc4,
  btc5,
  bch,
  eth,
  ltc,
  lefttwoline,
  moreright,
  btc6,
  btc7,
  btc8,
  btc9,
  btc10,
  market,
  crt1,
  crt2,
  exclamation,
  crt3,
  crt4,
  comp,
  assest,
  Yield,
  Wallet,
  cr1,
  cr2,
  cr3,
  lorarrow,
  mainbanneri,
  Yay,
  From,
  to,
  proto,
  pt1,
  pt2,
  pt3,
  pt4,
  warrr,
  down,
  goup3,
  hourr,
  up,
  sss,
  clock,
  linechart,
  bbbtc,
  rightarr,
  bnb,
  frame1,
  frame2,
  frame3,
  percentage,
  gotomarket,
  yielldmarket,
  qwq,
  defilogo,
  articlevideo,
  articleimage,
  stepOne,
  stepTwo,
  wallettop,
  stepThree,
  us,
  vn,
  ru,
  cap,
  notificationdot,
  thirdarticle,
  secondarticle,
  firstarticle,
};

export default Images;
